/**
 * @author Lorenzo Muscariello <lmuscariello@ciaopeople.com>
 */
import { AdUnit } from "../AdUnit.js";
import { WrappedImaAdsManager } from "./AbstractImaController.js";

/**
 * AD Item lifecycle statuses
 */
export enum AdItemStatus {

    INITIALIZED = 0, 
    LOADING = 1,
    LOADED = 2,
    PLAYING = 3,
    ENDED = 4,
    LOAD_ERROR = 5,
    PLAY_ERROR = 6

}


export type ProgressData = {
    duration: number,
    currentTime: number,
    progress: number
}

export type ProgressDataListener = (e: ProgressData) => void
/**
 * Ad Item general controls for ad media playback
 * and ad related resource release
 */
export type AdItemControls = {

    adInfo: () => Promise<google.ima.Ad>
    pause: () => Promise<void>,
    resume: () => Promise<void>,
    destroy: () => Promise<void>;
    close: () => Promise<boolean>;
    togglePlay: () => Promise<boolean>;
    toggleAudio: () => Promise<boolean>;
    unmute: () => Promise<boolean>;
    muted: (enable?: boolean) => Promise<boolean>;
    volume: (volume?: number) => Promise<number>;
    completionPromise: Promise<AdItemStatus>;
    alreadyCompleted(): boolean;
    onProgress(lst: ProgressDataListener): void;
    offProgress(lst: ProgressDataListener): void;
}

/**
 * Represents a playable (ima controllerd) ad item associated to an adunit 
 */
export interface ImaAdItem<UnitImpl extends AdUnit> {
    units: UnitImpl[],
    status: AdItemStatus,
    
    /**
     * eventually performs bid requests 
     */
    prepare(): void;
    /**
     * performs ima adrequest and wraps the associated `google.ima.AdsManager`
     * @returns a `WrappedImaAdsManager` instance
     */
    load(): Promise<WrappedImaAdsManager>,
    /**
     * starts ad item media playback
     * @returns controls for ad playback control
     */
    start(): Promise<AdItemControls>
}
